export enum SerpItemComponentEnum {
  CARESERVICE = 'careservice',
  CAREPROVIDER_WITH_SERVICES = 'careprovider-with-services',
}
